export default "__VITE_ASSET__DlGVj$QY__"